import React, { useState } from 'react'

function RelatedVideosMember() {
    const [relatedVideos,setrelatedVideos]=useState([1,2,3,4,5,8])
  return (
    <div className='w-full h-full flex justify-center' style={{fontFamily:'Ropa sans'}}>
        <div className='lg:w-10/12 w-11/12  h-64 mt-16 flex flex-col'>
           <div><h3 className='lg:text-left text-center mb-8 text-lg'>Related Videos</h3></div>
           {/* <div className='flex flex-col'> */}
            <div className='flex flex-wrap gap-6 lg:justify-between justify-center pb-10'>
                {relatedVideos?.map((videos)=>(
                    <div className='xl:h-36 h-60 hover:shadow-xl lg:w-3/12 w-2/5 rounded-lg flex xl:flex-row flex-col  justify-evenly' style={{border:'1px solid #001F33'}} >
                        {/* video img */}
                        <div className='flex items-center justify-evenly'><img className='md:w-24 w-16 md:h-24 h-16 rounded-full lg:ms-4 ms-0 lg:mt-0 mt-5' src="https://experiencekerala.in/kerala-tourism-blog/wp-content/uploads/2017/07/Niyamasabha.jpg" alt="Video logo" /></div>
                        {/* title and sub-title */}
                        <div className='flex flex-col xl:w-8/12 w-full '>
                            <div className='flex lg:justify-start justify-center'><p className='mt-6 lg:ms-6 ms-0 '>Budget Speach 1</p></div>
                            <div className='flex lg:justify-start justify-center lg:text-start text-center'> <p className='text-sm mt-2 lg:ms-6 ms-0'  style={{ color: '#878787' }}>Here comes the description which is very short...</p></div>
                        </div>
                    </div>
                ))}
               

                </div>
           {/* </div> */}
        </div>
    </div>
  )
}

export default RelatedVideosMember
